import { Observable, merge } from "rxjs";
import { map, skipWhile, startWith } from "rxjs/operators";
import { type AnyElement } from "@zyzgroup/core-common";
import { createEventListener$ } from "./createEventListener";

export async function resize(el: AnyElement, cb: (r: DOMRect) => void) {
  return new Promise<() => void>((resolve) => {
    const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      // const entry = entries[0];
      // const rect = entry.contentRect;
      const rect = el.getBoundingClientRect();
      cb(rect);
      resolve(() => {
        observer.unobserve(el);
      });
    });
    observer.observe(el);
  });
}

// 监听元素可见区域（content-box）尺寸的变化
export function resize$(
  el: AnyElement = document.documentElement,
  options?: ResizeObserverOptions
): Observable<DOMRect> {
  return new Observable((observer) => {
    // 起码要执行一次，类似 BehaviorSubject
    const rect = el.getBoundingClientRect();
    let prevX = rect.x;
    let prevY = rect.y;
    let prevWidth = rect.width;
    let prevHeight = rect.height;
    observer.next(rect);
    const ro = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      // const entry = entries[0];
      // const rect = entry.contentRect; // 有时 rect.x == 0 ？
      const rect = el.getBoundingClientRect();
      if (
        prevX != rect.x ||
        prevY != rect.y ||
        prevWidth != rect.width ||
        prevHeight != rect.height
      ) {
        prevX = rect.x;
        prevY = rect.y;
        prevWidth = rect.width;
        prevHeight = rect.height;
        observer.next(rect);
      }
    });
    ro.observe(el, options);
    return () => {
      ro.unobserve(el);
      ro.disconnect();
    };
  });
}

export function useWindowResize$(): Observable<{
  width: number;
  height: number;
}> {
  return createEventListener$(
    window,
    "orientationchange" in window ? "orientationchange" : "resize"
  ).pipe(
    map((e: Event | UIEvent) => {
      return {
        width: (e.target as Window).innerWidth,
        height: (e.target as Window).innerHeight
      };
    }),
    startWith({
      width: window.innerWidth,
      height: window.innerHeight
    })
  );
}

// 结果不准
// export function useDocumentContentChange$(): Observable<{
//   width: number;
//   height: number;
// }> {
//   let prevWidth: number;
//   let prevHeight: number;
//   return merge(
//     resize$(document.documentElement),
//     mutation$(document.body)
//   ).pipe(
//     map(() => ({
//       width: document.documentElement.offsetWidth,
//       height: document.documentElement.offsetHeight
//     })),
//     skipWhile((rect) => {
//       const _prevWidth = prevWidth;
//       const _prevHeight = prevHeight;
//       prevWidth = rect.width;
//       prevHeight = rect.height;
//       return _prevWidth == rect.width && _prevHeight == rect.height;
//     })
//   );
// }
